import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "How is this report created?",
      answer: "Our team uses your date, time, and place of birth to craft a personalized report using astrology principles."
    },
    {
      question: "Is this suitable for singles?",
      answer: "Absolutely! Our Love Report is designed for both singles and couples. For singles, it provides insights into your love nature, compatibility patterns, and guidance on finding the right partner."
    },
    {
      question: "How long will it take to receive my report?",
      answer: "Your personalized Love Report will be delivered within 24-48 hours after placing your order and providing your birth details."
    },
    {
      question: "What if I want deeper guidance?",
      answer: "We offer additional consultation packages where you can have a one-on-one session with a Senior Astrologer for more detailed guidance and personalized remedies."
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-background_lv">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground_lv mb-4">
            Frequently Asked Questions (FAQ)
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3 lg:space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card_lv border border-love-pink/20 rounded-lg px-4 lg:px-6 py-2"
              >
                <AccordionTrigger className="text-left font-semibold text-foreground_lv hover:text-love-primary text-sm lg:text-base">
                  <span className="text-love-primary font-bold mr-2">Q{index + 1}.</span>
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted_lv-foreground pt-2 pb-4 text-sm lg:text-base">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;